import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {PrimerComponentCardSchema} from './primerComponentCard'

export const PrimerCardsSchema = buildEntrySchemaFor('primerCards', {
  fields: z.lazy(() =>
    z.object({
      cards: z.array(PrimerComponentCardSchema),
      variant: z.enum(['default', 'gridline']).optional(),
      fullWidth: z.boolean().optional(),
    }),
  ),
})

export type PrimerCards = z.infer<typeof PrimerCardsSchema>
